import { render, staticRenderFns } from "./IntegrationFormBasicData.vue?vue&type=template&id=45a6ab9e&scoped=true&"
import script from "./IntegrationFormBasicData.vue?vue&type=script&lang=ts&"
export * from "./IntegrationFormBasicData.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationFormBasicData.vue?vue&type=style&index=0&id=45a6ab9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a6ab9e",
  null
  
)

export default component.exports